import moment from "moment";
import "moment/locale/pt-br";
import { contactPresentation } from "../CrmRelationship/helpers";

export const scheduleStatuses = {
  PREPARANDO: { label: "Aguardando confirmação", tone: "warning" },
  PENDENTE: { label: "Agendado", tone: "primary" },
  AGENDADA: { label: "Na fila", tone: "warning" },
  PROCESSANDO: { label: "Enviando", tone: "warning" },
  ENVIADA: { label: "Enviado", tone: "success" },
  ERRO: { label: "Falha no envio", tone: "error" },
  INCERTO: { label: "Verificar envio", tone: "warning" },
  CANCELADA: { label: "Cancelado", tone: "secondary" },
  EXPIRADA: { label: "Expirado", tone: "secondary" },
  DUPLICADA: { label: "Duplicado", tone: "secondary" }
};
export const statusInfo = status => scheduleStatuses[status] || { label: status || "Agendado", tone: "primary" };
export const isBirthdaySchedule = schedule => String(schedule?.externalId || "").startsWith("crm-birthday");
const isUiSchedule = schedule => String(schedule?.externalId || "").startsWith("ui-schedule:");
export const canEditSchedule = (schedule, user) => user?.profile === "admin" && !isBirthdaySchedule(schedule) && !(isUiSchedule(schedule) && ["CANCELADA", "EXPIRADA"].includes(schedule?.status)) && !["PROCESSANDO", "ENVIADA", "INCERTO"].includes(schedule?.status);
export const canDeleteSchedule = schedule => !isBirthdaySchedule(schedule) && !(isUiSchedule(schedule) && schedule?.status === "CANCELADA") && !["PROCESSANDO", "INCERTO"].includes(schedule?.status);

export function calendarPeriod(date, view) {
  const day = moment(date).locale("pt-br");
  let start, end;
  if (view === "month") {
    start = day.clone().startOf("month").startOf("week");
    end = day.clone().endOf("month").endOf("week").add(1, "millisecond");
  } else if (view === "week") {
    start = day.clone().startOf("week"); end = start.clone().add(1, "week");
  } else {
    start = day.clone().startOf("day"); end = start.clone().add(view === "agenda" ? 31 : 1, "days");
  }
  return { startDate: start.toISOString(), endDate: end.toISOString() };
}

export const contactLabel = contact => contactPresentation(contact).name;

export function scheduleDefaults(initialSendAt) {
  const candidate = moment(initialSendAt);
  return {
    body: "", contactId: "", whatsappId: "", ticketUserId: "", queueId: "",
    sendAt: (initialSendAt && candidate.isAfter() ? candidate : moment().add(1, "hour")).format("YYYY-MM-DDTHH:mm"),
    openTicket: "enabled", statusTicket: "closed", intervalo: 1,
    valorIntervalo: 0, enviarQuantasVezes: 1, tipoDias: 4, assinar: false, repeatEnabled: false
  };
}

export function schedulePayload(values, userId) {
  return {
    body: values.body, contactId: values.contactId, sendAt: new Date(values.sendAt).toISOString(),
    whatsappId: values.whatsappId, userId, openTicket: values.openTicket,
    ticketUserId: values.openTicket === "enabled" ? values.ticketUserId || null : null,
    queueId: values.openTicket === "enabled" ? values.queueId || null : null,
    statusTicket: values.statusTicket, assinar: values.openTicket === "enabled" && values.assinar,
    intervalo: Number(values.intervalo), valorIntervalo: Number(values.valorIntervalo),
    enviarQuantasVezes: Number(values.enviarQuantasVezes), tipoDias: Number(values.tipoDias)
  };
}
